const getProductCategories = (tags) => {
  const matchStrings = [
    "categories.lvl2:",
    "categories.lvl1:",
    "categories.lvl0:",
  ];

  // Separating into 3 arrays incase it has to be passed to builder.io separately for custom targeting
  let productTypes = [];
  let productCategories = [];
  let productSubCategories = [];

  // Parsing tags to get all types, categories, subcategories that the product belongs to
  if (tags) {
    for (let i = 0; i < matchStrings.length; i++) {
      for (let j = 0; j < tags.length; j++) {
        if (tags[j].startsWith(matchStrings[i])) {
          tags[j]
            .replace(matchStrings[i], "")
            .split(">")
            .forEach((element, index) => {
              const category = element.trim();
              if (index === 0) productTypes.push(category);
              if (index === 1) productCategories.push(category);
              if (index === 2) productSubCategories.push(category);
            });
        }
      }
    }
  }

  // Getting unique values in array
  productTypes = [...new Set(productTypes)];
  productCategories = [...new Set(productCategories)];
  productSubCategories = [...new Set(productSubCategories)];

  // Combining into one array since currently all types, categories, subcategories are passed combine to builder.io to a single "categories" or "categoryMenu" custom targeting attribut
  const combinedProductCategories = [
    ...new Set([
      ...productTypes,
      ...productCategories,
      ...productSubCategories,
    ]),
  ];

  return {
    combinedProductCategories,
    productTypes,
    productCategories,
    productSubCategories,
  };
};

// Get an array of handles of the collections that the product belongs to
const getProductcollectionIds = (collections) => {
  const collectionIds = [];
  if (collections) {
    collections.forEach((collection) => {
      collectionIds.push(collection.node.id);
    });
  }

  return collectionIds;
};

// global function for all pdp targeting data for builder custom components
export const getTargetingData = ({
  vendor,
  tags,
  productId,
  productHandle,
  collections,
  customerType,
  causePartner,
  rewardLevel ,
  app
}) => {
  const urlPath = `/product/${productHandle}`;

  const collectionIds = getProductcollectionIds(collections);

  const {
    combinedProductCategories,
    productTypes,
    productCategories,
    productSubCategories,
  } = getProductCategories(tags);

  return {
    urlPath: urlPath,
    product: [productId],
    collectionId: collectionIds,
    designers: [vendor, vendor.toLowerCase()],
    categoryMenu: combinedProductCategories,
    customerType:customerType,
    causePartner:causePartner,
    rewardLevel:rewardLevel,
    app:app
  };
};
